import Vue from 'vue'

Vue.directive('card', {
  bind: node => {
    node.addEventListener('mouseenter', () => {
      console.log(node)
    })
  },
})
